/**
 * Entrega de EPI ao funcionário — o formato do que `/v1/epi-entregas` devolve.
 */

export type TipoDeEntregaDeEpi = 'entrega' | 'troca' | 'devolucao';

export type StatusDaEntregaDeEpi =
  | 'aguardando_assinatura'
  | 'assinada'
  | 'recusada'
  | 'cancelada'
  | 'expirada'
  | 'sem_assinatura';

export const TIPOS_DE_ENTREGA: readonly TipoDeEntregaDeEpi[] = ['entrega', 'troca', 'devolucao'];

export const ROTULO_DO_TIPO: Record<TipoDeEntregaDeEpi, string> = {
  entrega: 'Entrega',
  troca: 'Troca',
  devolucao: 'Devolução',
};

export const STATUS_DA_ENTREGA: readonly StatusDaEntregaDeEpi[] = [
  'aguardando_assinatura',
  'assinada',
  'recusada',
  'expirada',
  'cancelada',
  'sem_assinatura',
];

export const ROTULO_DA_ENTREGA: Record<StatusDaEntregaDeEpi, string> = {
  aguardando_assinatura: 'Aguardando assinatura',
  assinada: 'Assinada',
  recusada: 'Recusada pelo funcionário',
  cancelada: 'Cancelada',
  expirada: 'Prazo vencido',
  sem_assinatura: 'Sem assinatura eletrônica',
};

export const COR_DA_ENTREGA: Record<StatusDaEntregaDeEpi, 'warning' | 'success' | 'error' | 'default' | 'info'> = {
  aguardando_assinatura: 'warning',
  assinada: 'success',
  recusada: 'error',
  cancelada: 'default',
  expirada: 'default',
  sem_assinatura: 'info',
};

export interface ItemDeEntregaDeEpi {
  id: number;
  epiId: number;
  quantidade: number;
  tamanho: string | null;
  nomeDoEpi: string;
  numeroDoCa: string;
  validadeDoCa: string | null;
}

export interface EntregaDeEpi {
  id: number;
  companyId: number;
  employeeId: number;
  tipo: TipoDeEntregaDeEpi;
  entregueEm: string;
  observacao: string | null;
  status: StatusDaEntregaDeEpi;
  documentoId: number | null;
  createdAt: string;
  itens: ItemDeEntregaDeEpi[];
  funcionario?: { id: number; name: string; employeeCode: string | null };
}

export interface NovaEntregaDeEpi {
  employeeId: number;
  tipo: TipoDeEntregaDeEpi;
  entregueEm: string;
  observacao: string;
  itens: { epiId: number; quantidade: number; tamanho: string }[];
  enviarParaAssinatura: boolean;
}

/** `2026-09-29` → `29/09/2026` sem passar por `Date`, que mudaria o dia pelo fuso. */
export function dataDaEntrega(iso: string | null): string {
  if (!iso) return '—';
  const [ano, mes, dia] = iso.slice(0, 10).split('-');
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : iso;
}
